<template>
  <div class="empty">
    <el-empty :image="emptyImage" :description="$t('noData')"></el-empty>
  </div>
</template>

<script>
export default {
  props: {
    emptyImage: {
      Type: String,
      require: true,
    },
  },
};
</script>

<style lang="less" scoped>
.empty {
  width: 100%;
  /deep/.el-empty {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 500px;
    }
    p {
      font-size: 26px;
      font-family: 'Lato Regular';
      color: #b8bbbf;
    }

    .el-empty__description {
      margin-top: 3px;
    }
  }
}
/deep/.el-empty__image {
  width: auto !important;
  margin-left: 80px;
}
</style>
